module.exports = __webpack_public_path__ + "files/accf356f2a8d7576d42f3dc1aa257675.png";